import { IAuthenticationRepository } from '../domain/IAuthenticationRepository'

export class IsUserAuthenticated {
  constructor(private readonly authenticationRepository: IAuthenticationRepository) {}

  async execute(): Promise<boolean> {
    return this.authenticationRepository.isAuthenticated()
  }
}
